import React from "react"
import { ThemeColor } from "@punks/core"
import classNames from "classnames"
import styles from "./index.module.css"
type Size = "small" | "medium" | "large"

interface RadioButtonClasses {
  root?: string
  input?: string
  label?: string
}
interface Props {
  color?: ThemeColor
  className?: string
  value?: boolean
  onChange?: (value: boolean) => void
  size: Size
  children?: React.ReactNode
  id?: string
  classes?: RadioButtonClasses
  radioControlColor?: string
  radioBgColor?: string
}

const CustomRadioButton = ({
  className,
  id,
  value,
  onChange,
  size,
  children,
  radioControlColor,
  radioBgColor,
  classes: userClasses,
}: Props) => {
  // const classes = useStyles({
  //   color,
  //   radioSize: getRadioSize(size),
  // })
  return (
    <div
      style={{
        ["--radio-control-color" as any]: radioControlColor ?? "#000",
        ["--radio-bg-color" as any]: radioBgColor ?? "#fff",
      }}
      className={classNames(
        "flex items-center py-2",
        className,
        userClasses?.root
      )}
    >
      {/* <Radio
        className={className}
        classes={{ root: classes.radio }}
        checked={value}

      />
      {children && (
        <div className={classes.label} >
          {children}
        </div>
      )} */}
      <input
        // {...rest}
        id={id}
        type="radio"
        checked={value}
        onChange={() => onChange?.(true)}
        className={classNames(
          styles.mtRadio,
          styles.black,
          "hidden overflow-hidden",
          userClasses?.input
        )}
      />
      <label
        onClick={() => onChange?.(true)}
        className={`flex items-center text-gray-400 transition-all duration-300 cursor-pointer select-none ${
          userClasses?.label ?? ""
        }`}
        htmlFor={id}
      >
        <span
          className={classNames(
            size === "medium" && "w-5 h-5",
            size === "small" && "w-4 h-4",
            size === "large" && "w-6 h-6",
            "relative inline-block mr-3 transition-all duration-300 border-2 border-solid rounded-full border-lightGray"
          )}
        ></span>
        {children}
      </label>
    </div>
  )
}

CustomRadioButton.defaultProps = {
  size: "medium",
  color: "black",
}

export default CustomRadioButton
